const linksNewTab = function () {
  'ngInject'
  return function (html) {
    // Parse in an inert document: unlike element.innerHTML, DOMParser never executes
    // scripts or inline event handlers (e.g. <img onerror>) while parsing.
    const doc = new DOMParser().parseFromString(html || '', 'text/html')
    doc.querySelectorAll('a').forEach(link => link.setAttribute('target', '_blank'))
    return doc.body.innerHTML
  }
}
export default linksNewTab
